export default __webpack_public_path__ + "static/media/port-yellow.d87679db.svg";